import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "canvas", "toggle"]

  declare sourceTarget: HTMLImageElement
  declare canvasTarget: HTMLCanvasElement
  declare toggleTarget: HTMLButtonElement

  private visualized = false
  private lut: Uint8Array[] | null = null

  connect() {
    this.lut = this.buildViridisLUT()
  }

  toggle() {
    this.visualized = !this.visualized
    if (this.visualized) {
      this.renderColorized()
      this.sourceTarget.classList.add("hidden")
      this.canvasTarget.classList.remove("hidden")
      this.toggleTarget.textContent = "Show raw"
    } else {
      this.sourceTarget.classList.remove("hidden")
      this.canvasTarget.classList.add("hidden")
      this.toggleTarget.textContent = "Visualize"
    }
  }

  private renderColorized() {
    const img = this.sourceTarget
    const canvas = this.canvasTarget
    canvas.width = img.naturalWidth
    canvas.height = img.naturalHeight
    const ctx = canvas.getContext("2d")!
    ctx.drawImage(img, 0, 0)
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
    const data = imageData.data

    for (let i = 0; i < data.length; i += 4) {
      const gray = Math.round(0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2])
      const color = this.lut![gray]
      data[i] = color[0]
      data[i + 1] = color[1]
      data[i + 2] = color[2]
    }

    ctx.putImageData(imageData, 0, 0)
  }

  private buildViridisLUT(): Uint8Array[] {
    const lut: Uint8Array[] = []
    for (let i = 0; i < 256; i++) {
      const t = i / 255
      let r: number, g: number, b: number
      if (t < 0.25) {
        const s = t / 0.25
        r = Math.round(68 * (1 - s) + 59 * s)
        g = Math.round(1 * (1 - s) + 82 * s)
        b = Math.round(84 * (1 - s) + 139 * s)
      } else if (t < 0.5) {
        const s = (t - 0.25) / 0.25
        r = Math.round(59 * (1 - s) + 33 * s)
        g = Math.round(82 * (1 - s) + 145 * s)
        b = Math.round(139 * (1 - s) + 140 * s)
      } else if (t < 0.75) {
        const s = (t - 0.5) / 0.25
        r = Math.round(33 * (1 - s) + 94 * s)
        g = Math.round(145 * (1 - s) + 201 * s)
        b = Math.round(140 * (1 - s) + 98 * s)
      } else {
        const s = (t - 0.75) / 0.25
        r = Math.round(94 * (1 - s) + 253 * s)
        g = Math.round(201 * (1 - s) + 231 * s)
        b = Math.round(98 * (1 - s) + 37 * s)
      }
      lut.push(new Uint8Array([r, g, b]))
    }
    return lut
  }
}
